import { jwtDecode } from 'jwt-decode';
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

function isJWTValid(token) {
	const currentTime = Date.now() / 1000;

	try {
		const decoded = jwtDecode(token);
		return decoded.exp > currentTime;
	} catch (error) {
		return false;
	}
}

interface UseValidateTokenOptions {
	optional?: boolean;
}

export const useValidateToken = (options?: UseValidateTokenOptions) => {
	const token = localStorage.getItem('token');
	const navigate = useNavigate();

	useEffect(() => {
		const unregisteredUser = JSON.parse(localStorage.getItem('unregisteredUser'));
		console.log('unregisteredUser', unregisteredUser);
		if (options?.optional && unregisteredUser) {
			return;
		}

		const isValid = isJWTValid(token);
		if (!isValid) {
			navigate('/login');
		}
		console.log('isJWTValid', isValid);
	}, []);
};

export const useIsUserLoggedIn = () => {
	const token = localStorage.getItem('token');

	const isValid = isJWTValid(token);

	return { isUserLoggedIn: isValid };
};

export const setToken = (token: string | null) => {
	if (token) {
		localStorage.setItem('token', token);
	} else {
		localStorage.removeItem('token');
	}
};
